import { ReactNode } from "react";
import { Box, Paper, Typography } from "@mui/material";

import { Column } from "../Layout/utils";

export type EmptyStateColor = "primary" | "warning" | "error";

type Props = {
  logo: ReactNode;
  text: string;
  subText: string;
  // Tints the logo badge; the logo itself should use the same color.
  color?: EmptyStateColor;
  children?: ReactNode;
};

const EmptyStateCard = ({
  logo,
  text,
  subText,
  color = "primary",
  children,
}: Props) => {
  return (
    <Paper
      sx={{
        textAlign: "center",
        padding: 2,
        height: 300,
        alignContent: "center",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          bgcolor: (theme) =>
            `rgba(${theme.vars.palette[color].mainChannel} / 0.12)`,
          p: 1.5,
          mb: 3,
        }}
      >
        {logo}
      </Box>
      <Column sx={{ marginBottom: children ? 2 : 0 }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, color: "text.primary" }}
        >
          {text}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {subText}
        </Typography>
      </Column>
      {children}
    </Paper>
  );
};

export default EmptyStateCard;
